import React from 'react';
import {COLORS} from '../../../../constants/colors';
import {Badge, BadgeProps} from './GenericBadges';
import {badgeColors} from './badgeColors';

/**
 * The in-basket / note badge applies the static black background / white text
 * pair (ASFE-14225). Colours are passed as props so the Linaria BadgeContainer
 * applies them directly — a styled-components override on top of it loses the
 * cascade tie against the container's own background-color rule.
 */
export const NoteBadge = (props: BadgeProps) => (
  <Badge
    {...props}
    textColor={COLORS.White}
    backgroundColor={badgeColors.backgroundColors.basket}
  />
);
